<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <div class="page-layout blank mat-white-bg">
        <mat-progress-bar class="orange-progress-bar" *ngIf="loading" mode="indeterminate"></mat-progress-bar>
        <div *ngIf="!loading">
            <div class="content" fxLayout="column">
                <div class="pb-16">
                    <div class="py-4" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="h4">{{
                            "Fecha de Ejecución" | translate
                            }}</span>
                        <span class="h4">{{ campaignData.execute_date }}</span>
                    </div>
                    <div class="py-4" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="h4">{{
                            "Última Fecha de Ejecución" | translate
                            }}</span>
                        <span class="h4">{{
                            campaignData.execute_end_date || "-"
                            }}</span>
                    </div>
                    <div class="py-4" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="h4">{{
                            "Tipo de Campaña" | translate
                            }}</span>
                        <span class="h4">{{ campaignData.type }}</span>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="py-16 grey-100-bg" *ngIf="chartData?.length">
                    <div class="position-relative h-200 pb-16">
                        <ngx-charts-bar-horizontal [results]="chartData" [scheme]="scheme" [yAxis]="true" [xAxis]="true"
                            [xAxisTickFormatting]="xAxisFormatting">
                        </ngx-charts-bar-horizontal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</wtf-dialogcontent>